import React, { useEffect, useState } from 'react';
import axios from 'axios';
import authHeader from "../services/AuthHeader";
import TableDisplay from './TableDisplay';
import { Button } from 'react-bootstrap';
import EditAdminModal from './EditAdminModal';
import DeleteAdminModal from './DeleteAdminModal';
import { useHistory } from "react-router-dom";

const ManageResults = (props) => {
    let history = useHistory();
    const initUser ={
            starId: '',
            firstName: '',
            lastName: '',
            email: ''
        };
    const [displayRes, setDisplayRes] = useState([]);
        
    const heading = ["Star Id", "First Name", "Last Name", "Email"];
    
    const [modalShow, setModalShow] = useState(false);
    const [modalDeleteShow, setModalDeleteShow] = useState(false);
    
    const [user, setUser] = useState(initUser);
    
    const [mode, setMode] = useState("");
    const [rerender, setRerender] = useState(false);
    
    const modalHide = ()=>{  
        setModalShow(false);
    }
    
    const showModal = ()=>{
        setModalShow(true)
    }
    
    const modalDeleteHide = ()=>{   
        setModalDeleteShow(false);
    }
    
    const showDeleteModal = ()=>{
        setModalDeleteShow(true)
    }
        
    useEffect(()=>{
        axios.get(
            process.env.REACT_APP_API_BASE + 'votingresults/',{ headers: authHeader() }
          )
        .then(res=>{
            if(res.data.length) {
                let arrRes = []
                let newObj = {};
                let chldArr = [["Candidate", "Votes", { role: 'annotation'}, { role: "style" }]];
                let bId = '';
        
                var longest = 0;
                var longestCur = 1;
                if(res.data) {
                  res.data.forEach((bal, i) =>  {
                    if (bId !== bal.ballotId) {
                      bId = bal.ballotId;
                      if (i) {
                        if (longestCur > longest) {
                          longest = longestCur
                        }
                        longestCur = 1;
                      }
                      bId = bal.ballotId;
                    }
                    longestCur++;
                  });
                }
                let ic = 0;
                let curBallotName = ''
                for (var i = 0; i < res.data.length; i++) {
                  if (bId !== res.data[i].ballotId) {
                    ic = 0;
                    if (i) {
                      newObj = {
                        ballotId: bId,
                        ballotName: curBallotName,
                        ballotArr: chldArr,
                      };
                      arrRes.push(newObj);
                      chldArr = [["Candidate", "Votes", { role: 'annotation'}, { role: "style" }]];
        
                    }
                    bId = res.data[i].ballotId;
                    curBallotName = res.data[i].ballotName;
                  }
                  if (bId === res.data[i].ballotId) {
                    ic++;
                    let chldObj = [
                      (res.data[i].candidateName ? res.data[i].candidateName: '') 
                      + (res.data[i].ballotCandidateName? res.data[i].ballotCandidateName : '') 
                      + (res.data[i].ballotCandidatePartyName ? ' - '+res.data[i].ballotCandidatePartyName : '')
                      + (res.data[i].ballotCandidateId && !res.data[i].ballotCandidatePartyName && !res.data[i].referendum ? ' - Independent' : '') 
                      + (!res.data[i].ballotCandidateId && !res.data[i].referendum ? ' (Write-In)' : ''),
                      res.data[i].cnt, res.data[i].cnt
                    ];
                    chldArr.push(chldObj);
                  }
                }
                newObj = {
                  ballotId: bId,
                  ballotName: curBallotName,
                  ballotArr: chldArr,
                };
                arrRes.push(newObj);
                chldArr = [["Candidate", "Votes", { role: 'annotation'}, { role: "style" }]];
                setDisplayRes(arrRes)
              } 
        });   
    }, [rerender]);

    useEffect(()=>{
        convertToCSV();
    }, [displayRes]);

    function convertToCSV() {
        let data = displayRes;
        let rows = "";

        data.forEach((x, i) => {
            data.forEach((y, j) => {
                if (j) {
                rows += `${y}\n`;
                }
            })
        });


        //const header = Object.keys(data[0]).join(",");
        //const rows = data.map(obj => Object.values(obj).join(","));
        //return `${header}\n${rows.join("\n")}`;
      }
   
return  (<>
    <h1 className='h2'>Manage Results</h1>
   
</>); 
}

export default ManageResults;
